const normalizeWorkbenchText = (value: unknown): string => {
  if (typeof value === 'string') {
    return value.trim()
  }

  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value)
  }

  return ''
}

export const workbenchSafeText = (value: unknown, fallback = ''): string => (
  normalizeWorkbenchText(value) || normalizeWorkbenchText(fallback)
)

export const workbenchOptionalText = (value: unknown): string | undefined => {
  const normalized = workbenchSafeText(value)
  return normalized || undefined
}

export const workbenchSafeNumber = (value: unknown, fallback = 0): number => (
  typeof value === 'number' && Number.isFinite(value) ? value : fallback
)

export const compareWorkbenchText = (left: unknown, right: unknown): number => (
  workbenchSafeText(left).localeCompare(workbenchSafeText(right), undefined, { sensitivity: 'base' })
)
